import { useTranslation } from 'react-i18next';
import type { IDeleteModuleButtonProps } from './IDeleteModuleButtonProps';
import { useModuleRemoval } from './useModuleRemoval';

/**
 * «Видалити модуль» (прототип v4 pgBuilder: червона обведена кнопка 32px ліворуч від «Відкрити модуль →», лише для неосновних модулів):
 * підтвердження з назвою модуля — власний модуль видаляється разом із записами, модуль каталогу вимикається в просторі (записи
 * зберігаються); недоступне видалення — кнопки немає.
 */
export function DeleteModuleButton({ ws, moduleKey, onDeleted }: IDeleteModuleButtonProps) {
  const { t } = useTranslation();
  const removal = useModuleRemoval(ws, moduleKey);
  if (!removal.available) return null;
  const onClick = async () => {
    if (!window.confirm(t(removal.custom ? 'rtBuilder.deleteCustomConfirm' : 'rtBuilder.disableConfirm', { name: removal.name }))) return;
    if (await removal.remove()) onDeleted?.();
  };
  return <button type="button" className="rb-delete" onClick={() => void onClick()}>{t('rtBuilder.deleteModule')}</button>;
}
